module.exports = __webpack_public_path__ + "static/media/190-Social-Banner@2x.75fcef70.jpg";